/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileDownloadResponse } from '../models/FileDownloadResponse';
import type { FileUploadResponse } from '../models/FileUploadResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CrmCustomFieldsFilesService {
    /**
     * Upload a file for a custom field
     * This endpoint does not associate the file with any custom field value
     * It only uploads the file and returns a value that can be used when creating/updating a custom field value
     * @param formData
     * @returns FileUploadResponse Ok
     * @throws ApiError
     */
    public static uploadFile(
        formData: {
            file: Blob;
            entityType: string;
            entityId: string;
        },
    ): CancelablePromise<FileUploadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/crm/custom-fields/files/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get a download URL for a file custom field value
     * @param fileId
     * @returns FileDownloadResponse Ok
     * @throws ApiError
     */
    public static getFileDownloadUrl(
        fileId: string,
    ): CancelablePromise<FileDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/crm/custom-fields/files/download/{fileId}',
            path: {
                'fileId': fileId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
